// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_76-0";